import React from "react";
import styled from "styled-components";
import rem from "../../utils/rem";
import Input from "../elements/Input";

const Wrapper = styled.div`
  margin-bottom: 15px;
`;

const Error = styled.p`
  color: palevioletred;
  font-size: ${rem(12)};
  margin: 0;
  padding-top: 5px;
`;

const TextInputLabel = styled.label`
  color: palevioletred;
  display: block;
  font-size: ${rem(14)};
`;

class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { onChangeHandler } = this.props;
    onChangeHandler(e.target.value);
  }

  render() {
    const { errorMessage, hasError, label, value } = this.props;

    return (
      <Wrapper>
        <TextInputLabel>{label}</TextInputLabel>
        <Input type="text" value={value} onChange={this.handleChange} />
        {hasError ? <Error>Error: {errorMessage}</Error> : null}
      </Wrapper>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/form/TextInput.js